var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 256,
    width: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
    fill: "none",
    stroke: "#5464B0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96,192v8a32,32,0,0,0,64,0v-8",
    fill: "none",
    stroke: "#5464B0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.4,24a105,105,0,0,1,38,42.1",
    fill: "none",
    stroke: "#5464B0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,66.1A105,105,0,0,1,72.6,24",
    fill: "none",
    stroke: "#5464B0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1f900a7038999e5b80478ff25619efaf.svg";
export { ForwardRef as ReactComponent };